const currencySymbols = {
    GBP: '£',
    USD: '$',
    EUR: '€',
}

export const formatAsCurrency = (price = 0, currency = 'GBP') => {
    return `${currencySymbols[currency]}${(price / 100).toFixed(2)}`
}